import React from 'react';
import ui from '../styles/primitives.module.css';

// Eyebrow + heading with a shimmering highlight phrase + optional lede.
const SectionHead = ({ eyebrow, title, highlight, lede }) => (
  <div className={ui.head} data-reveal="">
    <span className={ui.eyebrow}>{eyebrow}</span>
    <h2>
      {title} <span className={ui.grad}>{highlight}</span>
    </h2>
    {lede && <p>{lede}</p>}
  </div>
);

export default SectionHead;
